import React, { useState, useEffect } from 'react';

import './index.css';

const NewsUpdates = () => {
    const URL = `${process.env.PUBLIC_URL}/_data/home/news-updates.json`;

    const [content, setContent] = useState([]);

    useEffect(() => {
        // GET QuickLinks
        fetch(URL)
            .then((res) => res.json())
            .then((reply) => {
                setContent(reply);
            });
    }, []);

    return (
        <div className="news-window">
            <h3>News Updates</h3>
            <div className="news-trans-grad" />
            <div className="news-page">
                {/* <div className="news-grad-top" /> */}
                {content.map((item, index) => {
                    return (
                        <div className="news-widget" key={index}>
                            <p>
                                <span className="news-date">
                                    <span
                                        className={`${index < 3 ? 'new-item' : ''} nitem-${index}`}
                                    >
                                        {item.date}
                                    </span>
                                    &nbsp;&bull;&nbsp;
                                </span>
                                {item.content}
                            </p>
                        </div>
                    );
                })}
                {/* <div className="news-grad-bottom" /> */}
            </div>
        </div>
    );
};

export default NewsUpdates;
